import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M21.5 18.754a.75.75 0 0 0-.75-.75h-1.5a.75.75 0 0 0-.75.75v5.251h-3.055a.75.75 0 0 0-.528 1.283l4.52 4.485a.8.8 0 0 0 1.126 0l4.52-4.485a.75.75 0 0 0-.529-1.283H21.5v-5.25Zm9.614-8.63L25.871 4.88A3 3 0 0 0 23.753 4H11A3.01 3.01 0 0 0 8 7.006V33A3 3 0 0 0 11 36h17.996A3.004 3.004 0 0 0 32 33V12.249c0-.793-.323-1.562-.886-2.124Zm-7.117-2.875 4.756 4.755h-4.756V7.25ZM29 33.001H11V7.006h9.997v6.498c0 .832.67 1.5 1.5 1.5H29V33Z" })
});
export default SvgDownload;
